module.exports = __webpack_public_path__ + "static/media/feature-slideg2.71e60c09.jpg";